import React from 'react';
import { TextInput } from '../ui';

function TournamentCreateView({
  tournamentForm,
  setTournamentForm,
  saveTournament,
  tournamentLoading,
  setView
}) {
  return (
    <section className="card auth-card" style={{ marginBottom: "40px" }}>
      <h2 className="section-title">Create Tournament</h2>
      <form onSubmit={saveTournament} className="auth-form">
        <TextInput
          label="Tournament Name"
          value={tournamentForm.name}
          onChange={(v) => setTournamentForm((s) => ({ ...s, name: v }))}
          placeholder="e.g., Spring Championship"
          required
        />
        <TextInput
          type="date"
          label="Tournament Date (Optional)"
          value={tournamentForm.date}
          onChange={(v) => setTournamentForm((s) => ({ ...s, date: v }))}
        />
        <TextInput
          label="Location (Optional)"
          value={tournamentForm.location}
          onChange={(v) => setTournamentForm((s) => ({ ...s, location: v }))}
          placeholder="e.g., Community Center"
        />
        <div className="actions">
          <button
            className="btn btn-primary"
            type="submit"
            disabled={tournamentLoading}
          >
            {tournamentLoading ? "Creating..." : "Create Tournament"}
          </button>
          <button
            className="btn btn-muted"
            type="button"
            onClick={() => setView("season-detail")}
            disabled={tournamentLoading}
          >
            Cancel
          </button>
        </div>
      </form>
    </section>
  );
}

export default TournamentCreateView;
